export default [
  {
    name: 'GET_USER_DATA',
    callback: function () {
      const loggedIn = localStorage.getItem('default_auth_token');
      if (loggedIn === null) {
        return;
      }
      window.getApp.axios.get('/reseller/who_am_i')
        .then(response => {
          response.data.negative = response.data.balance < 0;
          response.data.balance = this.moneyFormat(response.data.balance) + ' ریال';
          window.getApp.currentUser = response.data;
        }).catch(error => {
          setTimeout(() => { window.open('/login') }, 1500);
          window.getApp.$emit('SHOW_ERROR', 'ناتوان در بازخوانی اطلاعات کاربری');
        });
    }
  },
  {
    name: 'APP_LOGIN_SUCCESS',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'خوش آمدید'
      };
      window.getApp.$emit('GET_USER_DATA');
      this.$router.push({ path: 'dashboard' });
    }
  },
  {
    name: 'APP_LOGIN_ERROR',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'red',
        text: 'خطا!'
      };/*
      this.$router.push({ path: 'dashboard' }); */
    }
  },
  {
    name: 'SHOW_ERROR',
    callback: function (msg) {
      this.snackbar = {
        show: true,
        color: 'red',
        text: msg
      };
    }
  },
  {
    name: 'SHOW_SUCCESS',
    callback: function (msg) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: msg
      };
    }
  },
  {
    name: 'APP_LOGOUT',
    callback: function (e) {
      this.$auth.logout();
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'خروج با موفقیت انجام شد.'
      };
      this.$router.replace({ path: '/login' });
    }
  },
  {
    name: 'APP_PAGE_LOADED',
    callback: function (e) {
    }
  },
  {
    name: 'APP_AUTH_FAILED',
    callback: function (e) {
      setTimeout(() => {
        window.location.href = '/panel/#/login';
        this.$router.replace({ path: '/login' });
      }, 770);
      this.$message.error('اطلاعات ورود شما منقضی شده است، مجدداً وارد شوید.');
    }
  },
  {
    name: 'APP_BAD_REQUEST',
    // @error api response data
    callback: function (msg) {
      this.$message.error(msg);
    }
  },
  {
    name: 'INVALID_FORM',
    // @error api response data
    callback: function (e) {
      console.log(e);
      this.snackbar = {
        show: true,
        color: 'error',
        text: 'لطفاً اطلاعات ضروری را تکمیل نمایید.'
      };
    }
  },
  {
    name: 'APP_REGISTER_ERROR',
    // @error api response data
    callback: function (msg) {
      this.snackbar = {
        show: false,
        color: 'red',
        text: msg
      };
    }
  },
  {
    name: 'APP_REGISTER_SUCCESS',
    callback: function (e) {
      this.$auth.logout();
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'ثبت نام با موفقیت انجام شد.'
      };
      this.$router.replace({ path: '/dashboard' });
    }
  },
  {
    name: 'APP_ACCESS_DENIED',
    // @error api response data
    callback: function (msg) {
      this.$message.error(msg);
      this.$router.push('/forbidden');
    }
  },
  {
    name: 'APP_RESOURCE_DELETED',
    // @error api response data
    callback: function (msg) {
      this.$message.success(msg);
    }
  },
  {
    name: 'APP_RESOURCE_UPDATED',
    // @error api response data
    callback: function (msg) {
      this.$message.success(msg);
    }
  },

];



// WEBPACK FOOTER //
// ./src/event.js